// Create DOM
import {createRoot} from 'react-dom/client'

// Libraries
import {Chart, registerables} from 'chart.js'
import {MsalProvider} from '@azure/msal-react'
import {QueryClient, QueryClientProvider} from 'react-query'
import axios from 'axios'

// Configurations and utils
import {AuthProvider, setupAxios} from './app/modules/auth'

// Components
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
import {AppRoutes} from './app/routing/AppRoutes'

/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/

import './_metronic/assets/sass/style.scss'

import './_metronic/assets/sass/plugins.scss'

import './_metronic/assets/sass/style.react.scss'

import {msalInstance} from './configs/msalInstance'

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */

/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */

setupAxios(axios)

Chart.register(...registerables)

const queryClient = new QueryClient()

const container = document.getElementById('root')

if (container) {
  createRoot(container).render(
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </MetronicI18nProvider>

        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
    </MsalProvider>
  )
}
